module.exports = __webpack_public_path__ + "img/mp-solution-icon-5.0a9ddc0b.png";